<ng-template #entry>
  <div class="p-4 flex gap-3 md:items-center">
    <div
      class="flex flex-col md:grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4 gap-x-6 gap-y-2 md:items-center justify-center flex-1"
    >
      <div class="grid grid-cols-2 md:flex gap-1.5 items-center">
        <ui-skeleton class="rounded-full h-3 w-[101px]" />
        <ui-skeleton class="rounded-full h-3 w-[99px]" />
      </div>
      <div class="grid grid-cols-2 md:flex gap-1.5 items-center">
        <ui-skeleton class="rounded-full h-3 w-[38px]" />
        <ui-skeleton class="rounded-full h-3 w-[108px]" />
      </div>
      <div class="grid grid-cols-2 md:flex gap-1.5 items-center">
        <ui-skeleton class="rounded-full h-3 w-[62px]" />
        <ui-skeleton class="rounded-full h-3 w-[74px]" />
      </div>
      <div class="grid grid-cols-2 md:flex gap-1.5 items-center">
        <ui-skeleton class="rounded-full h-3 w-[52px]" />
        <ui-skeleton class="rounded-full h-3 w-[108px]" />
      </div>
    </div>
    <div class="flex-none">
      <ui-skeleton class="block rounded-md h-8 w-8 md:w-[94px]" />
    </div>
  </div>
</ng-template>

<ul
  class="flex flex-col shadow-[0px_1px_1px_0px_rgba(0,0,0,0.05)] border border-outline dark:border-outline-darkmode rounded-lg overflow-hidden"
>
  <li class="border-b border-outline dark:border-outline-darkmode">
    <ng-container *ngTemplateOutlet="entry"></ng-container>
  </li>
  <li>
    <ng-container *ngTemplateOutlet="entry"></ng-container>
  </li>
</ul>
